import React from 'react';
import { withTranslation } from 'config/i18n';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
// React Components
import NewsLetterDialog from './NewsLetterDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 0),
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  title: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  listItem: {
    width: 'auto',
    display: 'inline-flex',
    margin: theme.spacing(0, 2),
    [theme.breakpoints.only('lg')]: {
      margin: theme.spacing(0, 1),
    },
    paddingTop: 0,
    paddingBottom: 0,
  },
  starItem: {
    color: theme.palette.primary.main,
    margin: theme.spacing(0, 0.5),
    '& $listItemText': {
      fontSize: '1rem',
      position: 'relative',
      top: theme.typography.pxToRem(4),
    },
  },
  listItemText: {
    fontSize: '0.8125rem',
    fontWeight: 'bold',
    marginTop: 0,
  },
  form: {
    display: 'flex',
    padding: theme.spacing(1, 0),
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  textField: {
    backgroundColor: theme.palette.grey[700],
    height: theme.typography.pxToRem(40),
    padding: theme.spacing(0, 3),
    fontSize: '0.9rem',
    cursor: ['pointer', '!important'],
    '& input': {
      cursor: ['pointer', '!important'],
    },
    '& input::placeholder': {
      color: '#dadada',
      opacity: 1,
    },
  },
  button: {
    borderRadius: 0,
    fontWeight: 'bold',
    paddingRight: theme.typography.pxToRem(20),
    paddingLeft: theme.typography.pxToRem(20),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const topics = [
  {
    text: 'layout:footer.deals',
  },
  {
    star: '*',
  },
  {
    text: 'layout:footer.rides',
  },
  {
    star: '*',
  },
  {
    text: 'layout:footer.special_events',
  },
];

const NewsLetter = ({ t }) => {
  const classes = useStyles();
  const [shouldRenderDialog, setShouldRenderDialog] = React.useState(false); // Only render dialog into the DOM on demand
  const [open, setOpen] = React.useState(false); // NewsLetter Dialog

  const handleNewsletterClick = () => {
    setShouldRenderDialog(true);
    setOpen(true);
  };
  return (
    <div className={classes.root}>
      <Typography component="p" className={classes.title}>
        {t('layout:footer.subscribe_to_newsletter')}
      </Typography>
      <List className={classes.list} disablePadding>
        {topics.map((topic) => (
          <ListItem
            key={topic.text}
            dense
            className={`${classes.listItem} ${
              topic.star ? classes.starItem : ''
            }`}
            disableGutters
          >
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t(topic.text) || topic.star}
            />
          </ListItem>
        ))}
      </List>
      <form className={classes.form} onClick={handleNewsletterClick}>
        <InputBase
          className={classes.textField}
          disabled
          placeholder={t('layout:footer.email_address')}
        />
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disableElevation
        >
          {t('layout:footer.subscribe')}
        </Button>
      </form>
      {shouldRenderDialog && (
        <NewsLetterDialog open={open} onClose={() => setOpen(false)} />
      )}
    </div>
  );
};

export default withTranslation(['layout'])(NewsLetter);
